import { get_colors } from "../../Colors/general";

export const mapDataForRadialBarChart = (record, teamName, keys, metric, showHamburger = false) => {

  if (!keys?.chronicKey || !keys?.acuteKey) {
    return [];
  }

  const {
    chronicKey,
    acuteKey
  } = keys;

  const decimals = metric?.decimal_places ?? 2;

  const chronicValue = Number(record[chronicKey]?.toFixed(decimals)) || 0;
  const acuteValue = Number(record[acuteKey]?.toFixed(decimals)) || 0;
  const options = {
    colors: [get_colors(teamName).middle, get_colors(teamName).lower],
    chart: {
      type: 'column',
      inverted: true,
      polar: true
    },
    title: {
      text: null
    },
    tooltip: {
      formatter: function () {
        return `<strong>${this.x}</strong>: ${this.point.y}`
      },
      outside: true
    },
    pane: {
      size: '85%',
      innerSize: '70%',
      startAngle: 180,
      endAngle: 500
    },
    xAxis: {
      tickInterval: 1,
      labels: {
        enabled: false
      },
      lineWidth: 0,
      categories: ['Acute', 'Chronic'],
      tickWidth: 0,
      gridLineWidth: 0,
    },
    yAxis: {
      lineWidth: 0,
      tickInterval: 25,
      reversedStacks: false,
      endOnTick: true,
      showLastLabel: true,
      gridLineWidth: 0,
      labels: {
        enabled: false
      }
    },
    plotOptions: {
      column: {
        stacking: false,

        borderWidth: 1,
        pointPadding: .1,
        groupPadding: 4,
      }
    },
    series: [

      {
        name: `Chronic ${chronicValue}`,
        data: [[0, chronicValue]],
        color: get_colors(teamName)?.lower
      },
      {
        name: `Acute ${acuteValue}`,
        data: [[1, acuteValue]],
        color: get_colors(teamName)?.middle
      }
    ],
    credits: {
      enabled: false
    },
    exporting: {
      enabled: showHamburger
    },
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'vertical',
      itemStyle: {
        fontSize: '12px',
        fontWeight: 'bold'
      },
      margin: 0,
      padding: 0
    }
  };

  return options;
};